import { Box, Button } from '@material-ui/core';
import TranslatedText from 'components/atoms/TranslatedText';
import BaseModal from 'components/molecules/BaseModal';
import { AppTextField } from 'components/molecules/FormControls';
import _ from 'lodash';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { ModalIDs } from 'redux/reducers/gl_modal_reducer/types';
import ModalActions from 'redux/reducers/gl_modal_reducer/actions';

interface IFormData {
  title: string | null;
  note: string | null;
  keep_private: boolean;
}

const formDefaultValue: IFormData = {
  title: null,
  note: null,
  keep_private: false,
};

interface IProps {
  onNoteAdd: (note: string) => void;
}
export const AddNoteForm = ({ onNoteAdd }: IProps) => {
  const dispatch = useDispatch();
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<IFormData>({
    defaultValues: formDefaultValue,
  });

  const closeModal = () => {
    dispatch(
      ModalActions.closeModalAction({
        modalID: ModalIDs.MODAL_ADD_NOTE,
      })
    );
  };

  const onSubmit = (data: IFormData) => {
    onNoteAdd(data.title as string);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <Box style={{ width: '400px' }}>
        <AppTextField
          variant="outlined"
          margin={'normal'}
          error={Boolean(_.get(errors, 'title', false))}
          helperText={_.get(errors, 'title', '')}
          rules={{}}
          fullWidth
          size={'medium'}
          id={'title'}
          control={control}
          label={<TranslatedText defaultText={'Title'} />}
          name={'title'}
        />
      </Box>
      <Box
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'center'}
        alignItems={'center'}
      >
        <Button
          variant={'contained'}
          color={'secondary'}
          style={{ borderRadius: 48, marginTop: '.5rem', width: '100%' }}
          type={'submit'}
        >
          <TranslatedText defaultText={'Create new note'} />
        </Button>
        <Button
          variant={'text'}
          color={'secondary'}
          style={{ borderRadius: 48, marginTop: '.5rem' }}
          onClick={closeModal}
        >
          <TranslatedText defaultText={'Cancel'} />
        </Button>
      </Box>
    </form>
  );
};

interface IParams {
  onNoteAdd: (note: string) => void;
}
const AddNoteModalWrapper = () => {
  return (
    <BaseModal
      modalID={ModalIDs.MODAL_ADD_NOTE}
      showExitIcon={true}
      contentProps={{ style: { padding: '2rem' } }}
      renderHeader={(params: IParams) => (
        <TranslatedText defaultText={'Add new note'} />
      )}
      renderContent={(params: IParams) => <AddNoteForm {...params} />}
    />
  );
};
export default AddNoteModalWrapper;
